import styled from 'styled-components';


export const OptionsWrapper = styled.div`
    width: 100%;

`;

type OptionTypes = {
    flexDirection?: string
    flexWrap?: string
    optionHeight?: string
}

export const Option = styled.div<OptionTypes>`
    display: flex;
    flex-direction: ${props => props.flexDirection || "row"};
    flex-wrap: ${props => props.flexWrap || "nowrap"};
    gap: 2px;
    //height: 145px;
    height:${props => props.optionHeight || "auto"};

    width: 100%;
    color: white;
    text-align: center;
    vertical-align: middle;

    font-size: 48px;
    cursor: pointer;
    margin-bottom: 20px;

    div {
        // width: ${props => props.flexWrap === "wrap" ? "49.5%" : "100%"};
    }

    :hover {
        filter: brightness(95%);
    }

`;

type TypeViewProps = {
    tabWidth?: string
}

export const TabView = styled.div<TypeViewProps>`
    background: #7CBE7B;
    border: 6px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 48px;
    line-height: initial;
    width: ${props => props.tabWidth || "100%"};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const NumberSpan = styled.span`
    display: inline-block;
`;


